import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiAxios from '../../helpers/apiAxios'

export const fetchCsdMonthlyReport = createAsyncThunk(
  'csdMonthly/fetchReport',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get('/api/v1/crm/release_forecast/reports/csd_monthly_report', {
        params
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

export const exportCsdMonthlyReport = createAsyncThunk(
  'csdMonthly/exportReport',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get('/api/v1/crm/release_forecast/reports/csd_monthly_report_export', {
        params,
        responseType: 'blob'
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

const initialState = {
  data: [],
  summary: {
    monthly_summary: {},
    grand_total: {
      built_up: 0,
      cold_formed: 0,
      sheeting: 0,
      total: 0
    }
  },
  totalRows: 0,
  currentPage: 1,
  perPage: 50,
  filters: {
    period: null,
    project_id: null,
    building_id: null
  },
  sort: {
    sort_field: 'project_name',
    sort_dir: 'asc'
  },
  loading: false,
  exporting: false,
  error: null
}

const csdMonthlySlice = createSlice({
  name: 'csdMonthly',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload
      state.currentPage = 1
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
      state.currentPage = 1
    },
    setSort: (state, action) => {
      state.sort = action.payload
    },
    clearFilters: (state) => {
      state.filters = {
        period: null,
        project_id: null,
        building_id: null
      }
      state.currentPage = 1
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCsdMonthlyReport.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCsdMonthlyReport.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.rows
        state.summary = action.payload.summary
        state.totalRows = action.payload.total_rows
        state.currentPage = action.payload.page
        state.perPage = action.payload.per_page
      })
      .addCase(fetchCsdMonthlyReport.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload?.error || 'Failed to fetch report'
      })
      .addCase(exportCsdMonthlyReport.pending, (state) => {
        state.exporting = true
        state.error = null
      })
      .addCase(exportCsdMonthlyReport.fulfilled, (state) => {
        state.exporting = false
      })
      .addCase(exportCsdMonthlyReport.rejected, (state, action) => {
        state.exporting = false
        state.error = action.payload?.error || 'Failed to export report'
      })
  }
})

export const { setPage, setPerPage, setFilters, setSort, clearFilters } = csdMonthlySlice.actions
export default csdMonthlySlice.reducer
